import { useQuery } from 'react-query';
import { getMymeDetailsAPI } from '@myme/api';
import { getMymeDetails } from '@myme/logic';
import { UUID } from '@myme/utils';

export const useGetMymeDetails = (mymeId: UUID, enabled = true) => {
  return useQuery(
    [...getMymeDetailsAPI.cacheKeys, mymeId],
    async () => {
      const { data } = await getMymeDetails(mymeId);
      return data;
    },
    { enabled }
  );
};
